<template>
  <div>

    <div class="row entity_sec" :class="'entity_sec_' + tabIndex">
      <div class="col-12">

        <div class="accordion_crd">
          <b-card-header header-tag="header" class="row sec_hd head" role="tab"  block v-b-toggle="('en_' + category.uuid + tabIndex)" variant="info">
            <div class="col-1 ic_container">
              <div class="ic ic-remove_circle"></div>
              <div class="ic ic-add_circle"></div>
            </div>
            <div class="col-10 hd_txt">
              <div>{{category.title}}</div>
            </div>
          </b-card-header>

          <b-collapse :id="'en_' + category.uuid + tabIndex" visible role="tabpanel">
            <b-card-body class="accordion_crd_content">

              <div class="row sec_content" v-if="category.courseRequirement">
                <div class="col-12 sec_txt">
                  <div>{{category.courseRequirement}}</div>
                </div>
              </div>

              <div class="row sec_content" v-if="category.description">
                <div class="col-12 sec_txt">
                  <div v-html="category.description"></div>
                </div>
              </div>

              <template v-if="(category.children.length > 0)">
                <template v-if="hasCatalogs">
                  <div class="list_container">
                    <template v-for="(course, i) in category.children">
                      <div class="list_row" v-if="course.entityType ==='catalog'" :key="course.uuid">
                        <div :class="(course.entitySubType ==='catalog')?'row course_row row_clickable': 'row course_row'" v-if="(course.entityType ==='catalog')" @click="gotoCatalog(course)">

                          <div class="col-4 thumbnail_panel">
                            <div class="thumbnail" :style="{background: setThumbnailBgColor(course.uuid)}">
                              <div v-html="setThumbnailTitle(course)"></div>
                            </div>
                            <div class="txt_container">
                              {{course.creditsEarned}}
                            </div>
                          </div>

                          <div class="col-8 col_title">
                            {{course.title}}
                          </div>

                        </div>
                      </div>
                    </template>
                  </div>
                </template>
                <template v-for="subCategory in category.children">
                  <template v-if="(subCategory.entityType ==='category')">
                    <tree-node :key="subCategory.title" :category="subCategory" :tabIndex="(tabIndex+1)"> </tree-node>
                  </template>
                </template>
              </template>

            </b-card-body>
          </b-collapse>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'tree-node',
    props: {category: {
      type: Object,
      required: true
    }, tabIndex:0},
    data () {
      return {
        isCoursesLoaded: false,
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        }
      }
    },
    mounted () {
      this.showLoader()
    },
    methods: {
      ...mapActions([
        'loadProgramCourseList',
        'updateProgramCourseStatus',
        'navigateUserToCourseDashboard'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      async updateCourseStatus (streamId, status) {
        let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
          this.resetPage()
        })
      },
      openStatusDropDown (course) {
        this.selectedStatus = course.courseStatus
        if (this.clickedCourse) {
          this.closeStatusDropDown(false)
        } else {
          this.clickedCourse = course
          setTimeout(() => {
            this.$refs.courseStatusPopover.$emit('open')
          }, 250)
        }
      },
      closeStatusDropDown (toBeUpdated, status) {
        if (toBeUpdated) {
          this.updateCourseStatus(this.clickedCourse.uuid, status)
        }
        this.clickedCourse = ''
        this.selectedStatus = ''
        this.$refs.courseStatusPopover.$emit('close')
      },
      isStudentLogin () {
        return (localStorage.getItem('userrole') === 'Student')
      },
      gotoCatalog(catalog){
        if(catalog.entitySubType ==='catalog'){
          window.location="/vue/#/catalog/"+catalog.uuid+"/home"
        }
      },
      hasCatalogs (){
        for(i=0;i<this.category.children.length>0;i++){
            if(this.category.children[i].entityType==='catalog'){
                return true
            }
        }
        return false
      },
      launchCourse (courseId) {
        let token = localStorage.getItem('token')
        this.navigateUserToCourseDashboard({courseId: courseId, token: token}).then(href => {
          window.open(href, '_blank')
        })
      }
    }
  }
</script>

<style>
  .title-txt {
    color: #fff;
    margin-top: 3px;
    font-weight: 500;
    text-align: center;
  }

  div[id^="courseStatusPopup-"] .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 220px !important;
    width: 220px !important;
    height: 225px !important;
    margin-top: 15px;
  }

  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;
  }

  .form-check-input {
    top: 1px;
    cursor: pointer;
  }

  .status-not-started {
    background: #b4b4b4 !important;
  }

  .status-in-progress {
    background: #dd9623 !important;
  }

  .status-completed {
    background: #0a7714 !important;
  }

  .status-not-completed {
    background: #f40909 !important;
  }
  .row_clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/TreeNode.vue